export const MAX_CRUSH_COUNT = 50;

export const BULLETS_PER_CAR = 20;

export const CAR_CRUSHER_COOLDOWN = 6 * 60 * 60; // 6 hours

export const CRUSHER_ADMIN_UPDATE_COOLDOWN = 12 * 60 * 60; // 12 hours